import o from "./Overlay.vue2.js";
import "./Overlay.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ r(o, [["__scopeId", "data-v-f21587c6"]]);
export {
  m as default
};
